// import Utils from './utils.js';
import { eventBus, EVENTS } from './EventBus.js';
import API from './Api.js';
import { Paginator } from './paginator.js';

const REFRESH_BLOCCO_PLAYER = 'REFRESH_BLOCCO_PLAYER';
const TEMPO_REFRESH = 30000;
let first = true;
let keyboardOpen = false;
let opening = false;
let curWidth = $(window).width();
let can_be_open = false;
let is_middle = false;
let testDavide = true;
let stopTremolio = false;
let intervalInitiator = false;
let interval;
let isHome=false;
let isScrolling=false;

const CCE_CONTAINER = '#header-che_canzone_era_homepage';

class BloccoPlayer {

    constructor() {

        this.timeout = false;
        this.paginatore_ccce = false;
        this.currentSong = {};
        this.songs = [];
        this.fasce = {};



        /* emoji per versione desktop */
        // if (!getMobileOperatingSystem()) {
            // $(".textarea-desktop").emojioneArea({
            //     inline: true,
            //     search: false,
            //     recentEmojis: false,
            //     hideSource: true,
            //     filtersPosition: "bottom",
            //     tones: false,
            //     events: {
            //         'picker.show'(picker) { },
            //         'picker.hide'(picker) { }
            //     }
            // });
            /* emoji per versione sticky */
            //commentata per ora
            // $(".textarea-sticky").emojioneArea({
            //     inline: true,
            //     search: false,
            //     recentEmojis: false,
            //     hideSource: true,
            //     filtersPosition: "bottom",
            //     pickerPosition: "bottom",
            //     tones: false,
            //     events: {
            //         'picker.show'(picker) { },
            //         'picker.hide'(picker) { }
            //     }
            // })
        // }




    }

    initBloccoPlayer() {
        /* CHE CANZONE ERA */
        /*         API.get("site/che_canzone_era", {}, (resp) => {
                    const now = new Date();
                    let isSongOnAir = false;
                    if (JSON.stringify(resp.songs) == JSON.stringify(this.songs)) {
                        return;
                    }
                    // if (first) {
                    //     resp.songs.splice(0, 1);
                    // }
                    if (window.cceSongs) {
                        this.songs = window.cceSongs;
                        for (let i = 0; i < window.cceSongs.length; i++) {
                            const value = window.cceSongs[i];
                            let startTime = new Date(value.air_start_time);
                            let endTime = new Date(value.air_start_time);
                            endTime.setSeconds(endTime.getSeconds() + Number(value.duration));
                            if (now >= startTime && now <= endTime) {
                                const song = {
                                    traccia: value.song_title,
                                    artista: value.song_artist,
                                    likes: value.likes,
                                    id: value.sid,
                                    masterID: value.music_log_idmusicdb
                                }
                                let cont=$('.single_che_canzone_era')[0];
                                if($(cont).find('.cce_title').text()==song.traccia){
                                   $(cont).remove();
                                }
                                this.songs=this.songs.filter(s => s.sid!=song.id);
                                resp.songs=resp.songs.filter(s => s.sid!=song.id);
                                isSongOnAir = true;
                                this.riempiNowPlaying({ song: song });
                                break;
                            }
                        }
                        delete window.cceSongs;
                    }

                    // $("#list_che_canzone_era").empty();
                    const songIds = this.songs.map(s => s.sid);
                    const newSongs = resp.songs.filter(s => songIds.indexOf(s.sid) === -1);
                    this.songs = resp.songs;
                    let root = document.documentElement;
                    $(newSongs).each((index, value) => {
                        if (!window.player.playing() && !isSongOnAir) {
                            let startTime = new Date(value.air_start_time);
                            let endTime = new Date(value.air_start_time);
                            endTime.setSeconds(endTime.getSeconds() + Number(value.duration));
                            if (now >= startTime && now <= endTime) {
                                const song = {
                                    traccia: value.song_title,
                                    artista: value.song_artist,
                                    likes: value.likes,
                                    id: value.sid,
                                    masterID : value.music_log_idmusicdb
                                }
                                this.riempiNowPlaying({ song: song });
                                isSongOnAir = true;
                                this.songs=this.songs.filter(s => s.sid!=song.id);
                                return;
                            }
                        }

                        let template = window.templates["che_canzone_era_homepage"];
                        template = template.replace("{{song_image}}", value.song_image).replace("{{song_onair_time}}", value.song_onair_time).replace("{{song_title}}", value.song_title).replace("{{song_artist}}", value.song_artist);
                        $(CCE_CONTAINER).addClass('no-transition');
                        $(CCE_CONTAINER).prepend(template);
                        root.style.setProperty('--new-songs', (1));
                        setTimeout(() => {
                            $(CCE_CONTAINER).removeClass('no-transition');
                            root.style.setProperty('--new-songs', 0);
                        }, 300);

                    });
                    if (!isSongOnAir) {
                        this.riempiNowPlaying({});
                    }

                    // this.paginatore_ccce.reset();
                }, function (error) {
                    console.log(error);
                }); */

        /* FASCE IN ONDA  */
        API.get("site/get_fasce_onair", {}, (resp) => {
            let fasce = {
                prec: resp.prec,
                onair: resp.onair,
                succ: resp.succ
            };
            if (JSON.stringify(fasce) == JSON.stringify(this.fasce)) {
                return;
            }
            this.fasce = fasce;
            if (resp.status == "0") {
                $("#player_prev_title").html(resp.prec.conduzione_nome);
                $("#player_onair_title").html(resp.onair.conduzione_nome);
                $('#current_talk_conduttori').html(resp.onair.conduzione_nome.replace('&', 'e'));
                $('#current_talk_date').html(resp.onair.ora_inizio + '.00');
                // $("#player_succ_time").html(resp.succ.ora_inizio + ":00");
                $("#player_succ_title").html(resp.succ.conduzione_nome);
            }
        }, function (error) {
            console.log(error);
        });

        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            $(document).trigger(REFRESH_BLOCCO_PLAYER);
        }, TEMPO_REFRESH);
    }
    initPaginator() {
        const breakpoints = [
            { maxWidth: 650, perPage: 2 },
            { maxWidth: 1150, perPage: 5 },
            { perPage: 3 }
        ];

        this.paginatore_ccce = new Paginator($('.pagination_blocco'), { total: 9, breakpoints: breakpoints, cssVar: '--cce_paginator', swipeElementSelector: '#header-che_canzone_era_homepage' });
    }

    newRiempiNowPlaying(song, isCurrent) {
        $('.container_now_playing_talk').hide();
        $('.container_now_playing_song').show();
        if (song) {
            const isNowPlaying = $('#now_playing .title_blocco_player span').text() == 'ORA IN ONDA...';
            if (isNowPlaying && $('#now_playing .container_set_preferito').attr('data-id') == song.id) {
                return;
            }
            $('.container_now_playing_talk').hide()
            $('#current_song_title').text(song.title);
            $('#current_song_artist').text(song.artist);
            $('#player_counter_like').text(song.likes);
            $('#now_playing .img_now_playing').attr('src', `https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i${song.id}`);
            $('#now_playing .container_set_preferito').attr('data-id', song.id);
            $('#now_playing .container_set_preferito').attr('data-masterid', song.master_control);
            let onAirText = isCurrent ? 'ORA IN ONDA...' : 'TRA POCO...';
            let onAirTextCollapsed = isCurrent ? '' : '<span style="margin-right: 7px;">TRA POCO</span><span style="margin-right: 7px;">|</span>';
            if ($('#now_playing .title_blocco_player span').text != onAirText) {
                $('#now_playing .title_blocco_player span.next').text(onAirText);
                $('#next_song_collapsed').html(onAirTextCollapsed);
                $('#now_playing').addClass('entering');
                setTimeout(() => {
                    $('#now_playing .title_blocco_player span.current').text(onAirText);
                    $('#next_song_collapsed').html(onAirTextCollapsed);
                    $('#now_playing').removeClass('entering');
                }, 3000);
            }
            $(".set_preferiti").removeClass("liked");
            window.setMyFavorite();

        }
    }

    // riempiNowPlaying({ song }) {

    //     $('.container_now_playing_talk').hide();
    //     $('.container_now_playing_song').show();
    //     if (song) {
    //         const isNowPlaying = $('#now_playing .title_blocco_player span').text() == 'NOW PLAYING..';
    //         if (isNowPlaying && $('#now_playing .container_set_preferito').attr('data-id') == song.id) {
    //             return;
    //         }
    //         $('.container_now_playing_talk').hide()
    //         $('#current_song_title').text(song.traccia);
    //         $('#current_song_artist').text(song.artista);
    //         $('#player_counter_like').text(song.likes);
    //         $('#now_playing .img_now_playing').attr('src', `https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i${song.id}`);
    //         $('#now_playing .container_set_preferito').attr('data-id', song.id);
    //         $('#now_playing .container_set_preferito').attr('data-masterid', song.id_master_control);
    //         $('#now_playing .title_blocco_player span.next').text('ORA IN ONDA..');
    //         $('#now_playing').addClass('entering');
    //         setTimeout(() => {
    //             $('#now_playing .title_blocco_player span.current').text('ORA IN ONDA..');
    //             $('#now_playing').removeClass('entering');
    //         }, 3000);

    //         $(".set_preferiti").removeClass("liked");
    //         window.setMyFavorite();

    //     } else {
    //         const isNowPlaying = $('#now_playing .title_blocco_player span').text() == 'ORA IN ONDA..';
    //         API.get('/site/status_song', {}, (resp) => {
    //             let song = resp.current_song;

    //             let nowPlayingTitle = 'ORA IN ONDA..';
    //             let next_collapsed = "";
    //             if (resp.current_song.type != 'song') {
    //                 song = resp.next_song;
    //                 nowPlayingTitle = 'TRA POCO..';
    //                 next_collapsed = "TRA POCO &nbsp; | &nbsp;";
    //             }
    //             const songId = song.cover.split('/').reverse()[0].substring(1);
    //             if (!isNowPlaying && $('#now_playing .container_set_preferito').attr('data-id') == songId) {
    //                 return;
    //             }

    //             $('#current_song_title').text(song.title);
    //             $('#current_song_artist').text(song.artist);
    //             $('#now_playing .img_now_playing').attr('src', song.cover);
    //             $('#now_playing .container_set_preferito').attr('data-id', songId);
    //             $('#now_playing .container_set_preferito').attr('data-masterid', song.id_master_control);
    //             $('#next_song_collapsed').html(next_collapsed);
    //             // $('#now_playing .title_blocco_player span').text(nowPlayingTitle);
    //             $('#now_playing .title_blocco_player span.next').text(nowPlayingTitle);
    //             $('#now_playing').addClass('entering');
    //             setTimeout(() => {
    //                 $('#now_playing .title_blocco_player span.current').text(nowPlayingTitle);
    //                 $('#now_playing').removeClass('entering');
    //             }, 400);
    //             $(".set_preferiti").removeClass("liked");
    //             window.setMyFavorite();
    //         });


    //         // $('.container_now_playing_song').hide()
    //         // $('.container_now_playing_talk').show()
    //     }

    // }
    initNowPlaying() {
        /*    player.on('metadata', (e) => {
                try {
                    if (e.type == 'song') {

                        // recupero l'eventuale lyrics
                        if (e.song.traccia != $('#current_song_title').text()) {

                            API.get("site/get_song", { idsong: e.song.idMasterControl }, function (resp) {

                                    if(resp.status == 1){

                                        $(".che_canzone_era_header_title").html(resp.data.music_log_title);
                                        $(".che_canzone_era_header_artist").html(resp.data.music_log_artist);
                                        if (resp.data.lyrics != "none") {

                                            var lyrics = resp.data.lyrics;
                                            lyrics = lyrics.replace(/\n/g, '<br>');
                                            lyrics = lyrics.replace('<br><br>', '<br>');


                                            $(".che_canzone_era_header_lyrics").html(lyrics);

                                        } else {
                                            //
                                            // $(".che_canzone_era_header_title").html("");
                                            // $(".che_canzone_era_header_artist").html("");
                                            $(".che_canzone_era_header_lyrics").html("Testo non presente per questo brano");

                                        }
                                    }
                            });

                        }
                        console.log(e.song.id);
                        window.last_song_played = e.song.id;
                        // if(window.last_song_played != e.song.id){
                            this.riempiNowPlaying({ song: e.song });
                        // }
                    } else {
                        this.riempiNowPlaying({});
                    }
                } catch (error) {
                    console.warn(error);
                }
            });
        */
    }
    onNewCceSong(song) {
        let root = document.documentElement;
        let template = window.templates["che_canzone_era_homepage"];
        const songImage= song.song_image|| song.music_log_cover_400x400;
        const songOnAir= song.song_onair_time;
        const songTitle= song.song_title || song.title;
        const songArtist= song.song_artist || song.artist;
        template = template.replace("{{song_image}}", songImage).replace("{{song_onair_time}}", songOnAir).replace("{{song_title}}", songTitle).replace("{{song_artist}}", songArtist);
        $(CCE_CONTAINER).addClass('no-transition');
        $(CCE_CONTAINER).prepend(template);
        root.style.setProperty('--new-songs', (1));
        setTimeout(() => {
            $(CCE_CONTAINER).removeClass('no-transition');
            root.style.setProperty('--new-songs', 0);
        }, 300);
    }

    initListeners() {
        eventBus.on(EVENTS.CCE_NEW_SONG, this.onNewCceSong);
        eventBus.on(EVENTS.NEXT_SONG, (song) => { this.newRiempiNowPlaying(song, false) });
        eventBus.on(EVENTS.CURRENT_SONG, (song) => { this.newRiempiNowPlaying(song, true) });
    }

    riempiMessaggiAllaDiretta() {

        $.getJSON("https://media.rds.it/web/web-site/json/v1/messages/rds_web", function (data) {

            let msg_array = data.messages;

            msg_array = msg_array.reverse();

            $("#container_chat, #container_chat_mobile").empty();

            $.each(msg_array, function (index, value) {

                if (value.servizio === 'a') {
                    var img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-appp.svg";
                } else if (value.servizio === 'whatsapp') {
                    var img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-whtsapp.svg";
                } else if (value.servizio === 'web') {
                    var img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-web.svg";
                } else {
                    var img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-msg.svg";
                }

                if (value.message.indexOf("Vocale:") == 0) {
                    img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-rec.svg";
                    value.message = value.message.replace("Vocale:", "");
                }

                let html = window.templates["simple_message_homepage"];
                html = html.replace("{{message}}", value.message).replace("{{src}}", img_src);

                $("#container_chat, #container_chat_mobile").append(html);

            });

            setTimeout(function () {
                $("#container_chat").animate({ scrollTop: $('#container_chat').prop("scrollHeight") }, 1000);
                $("#container_chat_mobile").animate({ scrollTop: $('#container_chat_mobile').prop("scrollHeight") }, 1000);
            }, 100);

        });

    }
    scrollDownMessaggiAllaDiretta(container) {
        setTimeout(function () {
            $(container).animate({ scrollTop: $(container).prop("scrollHeight") }, 1000);
        }, 100);
    }
}

let bloccoPlayer = new BloccoPlayer();
let closeMenu = false;

$(document).ready(function () {
    $('.sub_menu_container').mouseleave((e) => {
        console.log(e.currentTarget);
        $(e.currentTarget).one('mouseenter', () => {
            closeMenu = false;
            // console.log('mouseenter closeMenu', closeMenu);

        });
        closeMenu = true;
        setTimeout(() => {
            // console.log('mouseleave closeMenu', closeMenu);

            if (closeMenu) {
                closeAllMenu();
                closeMenu = false;
            }
        }, 300);
    })
    bloccoPlayer.initBloccoPlayer();
    bloccoPlayer.initPaginator();
    bloccoPlayer.initNowPlaying();
    bloccoPlayer.riempiMessaggiAllaDiretta();
    bloccoPlayer.initListeners();
    $(document).on(REFRESH_BLOCCO_PLAYER, function () {
        bloccoPlayer.initBloccoPlayer();
        bloccoPlayer.riempiMessaggiAllaDiretta();
    });

});

// VECCHIA VERSIONE
//
// eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
//   const template = data.template;
//
//   if (template != "home" && template != "homepage") {
//     chiudiPlayer();
//
//   } else {
//     // apriPlayer();
//     $("#blocco_player").show();
//     $(".player-explode").addClass("open");
//     $(".testo_helper_player").html("CHIUDI");
//   }
// });

// NUOVA VERSIONE
eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
    const template = data.template;

    if (template != "home" && template != "homepage") {
        isHome=false;
        chiudiPlayer();
        // clearInterval(interval);
    } else {
        // apriPlayer();

      if (window.innerWidth > 800) {

          isHome=true;
        //   $("#blocco_player").show();
        //   $(".player-explode").addClass("open");
        chiudiPlayer();
          if(window.radioId == 13){
            $("#blocco_player").addClass("collapsed");
            }
        
          // setTimeout(function(){
          //   $("#open_player_sticky").trigger("click");
          // }, 13000);
      } else{
        chiudiPlayer();
      }
        // if(!intervalInitiator){
          // autoOpeningPlayer();
        // }
        // $(".testo_helper_player").html("CHIUDI");
    }
});


function autoOpeningPlayer(){

  var timerPlayer = ()=>{
    if(interval){
      clearInterval(interval);
    }
    interval = setInterval(function(){
      isScrolling = true;
      console.log("DENTRO INTERVAL");
      $("#open_player_sticky").trigger("click");
      // clearInterval(interval);
    }, 7000);
  };
  timerPlayer();

  intervalInitiator = true;
  if(isHome){
    $(window).scroll(function () {

      if(isScrolling){
          // setTimeout(function(){
            isScrolling = false;
            clearInterval(interval);
            console.log("qui");
            timerPlayer();
          // }, 7000);
      }
    });
    // $(document).on({
    //   click: function () {
    //
    //     // debugger
    //   }
    // }, "#open_player_sticky");
  }
}




// PARTE COMMENTATA PLAYER OLD

$(document).on("click", "#container_button_open_right, #player_lyrics", function () {

    toggleRightMenu($(this));
});

function toggleRightMenu(me) {

    if (window.innerWidth >= 650) {
        if(!$("#icona_lyrics").hasClass("disabled")){
            $("#container_button_open_right").toggleClass("open");

            if($("#container_button_open_right").hasClass("open")){
                openLyrics($("#icona_lyrics"));
            } else{
                $(".icona_player").removeClass("selected");
                $("#extra_right_content").removeClass("open");
                $("#container_button_open_right").removeClass("open");
            }
        }else{
            openChat($("#icona_chat"));
        }
    } else {
        $("#icona_lyrics_mobile").trigger("click");
    }

}

$(document).on("click", ".icona_player", function () {

    if ($(this).hasClass("lyrics")) {
        openLyrics(this);
    } else {
        openChat(this);
    }
});



function openLyrics(me) {
    if(!$(me).hasClass("disabled")){
        if (window.innerWidth >= 650) {

                eventBus.emit(EVENTS.LIVE_LYRICS_DROPDOWN);
                toggleOption("lyrics", me);

        } else {
            $(".option_action_player").hide();
            $(".icona_player").not(me).removeClass("selected_mobile");
            $(me).toggleClass("selected_mobile");

            if ($(me).hasClass("selected_mobile")) {
                $("#content_lyrics_mobile").show();
                $("#mobile_player").addClass("open");
                $("#extra_right_content_mobile").addClass("open");
            } else {
                $("#content_lyrics_mobile").hide();
                $("#mobile_player").removeClass("open");
                $("#extra_right_content_mobile").removeClass("open");
            }
            eventBus.emit(EVENTS.LIVE_LYRICS_DROPDOWN);

            //
            //     setTimeout(() => {
            //
            //         $("#content_chat_mobile").fadeIn();
            //         bloccoPlayer.scrollDownMessaggiAllaDiretta("#container_chat_mobile");
            //
            //     }, 400);

        }
    }

}


function openChat(me) {
    if (window.innerWidth >= 650) {
        eventBus.emit(EVENTS.LIVE_CHAT_DROPDOWN);
        toggleOption("chat", me);
        bloccoPlayer.scrollDownMessaggiAllaDiretta("#container_chat");
    } else {
        $(".option_action_player").hide();
        $(".icona_player").not(me).removeClass("selected_mobile");

        $(me).toggleClass("selected_mobile");
        if ($(me).hasClass("selected_mobile")) {
            $("#content_chat_mobile").show();
            $("#mobile_player").addClass("open");
            $("#extra_right_content_mobile").addClass("open");
        } else {
            $("#content_chat_mobile").hide();
            $("#mobile_player").removeClass("open");
            $("#extra_right_content_mobile").removeClass("open");
        }
        eventBus.emit(EVENTS.LIVE_CHAT_DROPDOWN);
        setTimeout(() => {
            bloccoPlayer.scrollDownMessaggiAllaDiretta("#container_chat_mobile");
        }, 400);
    }
}


function toggleOption(type, me) {

    $(".icona_player").not($(me)).removeClass("selected");

    if ($(me).hasClass("selected")) {
        $("#extra_right_content").removeClass("open");
        $("#container_button_open_right").removeClass("open");
    } else {
        $("#extra_right_content").addClass("open");
        $("#container_button_open_right").addClass("open");

    }

    $(".option_action_player").hide();
    if (type == "lyrics") {
        $("#content_lyrics").toggle();
    } else {

        setTimeout(() => {
            $("#content_chat").toggle();
            bloccoPlayer.scrollDownMessaggiAllaDiretta("#container_chat");

        }, 400);

    }
    $(me).toggleClass("selected");

}


$(document).on('click', '#sticky_nav input, #sticky_nav textarea, #sticky_nav .emojionearea-editor', (e) => {
    if (!getMobileOperatingSystem()) {
        return;
    }
    keyboardOpen = true;
    // if(e.type=='focusin'){
    //     keyboardOpen=true;
    // // }else if(e.type=='focusout'){
    // //     keyboardOpen=false;
    // }
    const oldValue = $(window).height();
    $(window).one('resize', (e) => {
        const newValue = $(window).height();
        console.log('resize - oldValue:', oldValue, 'newValue:', newValue);
        // const diff=oldValue - newValue;
        $('#sticky_nav').css('transform', `translateY(calc(-100% + ${newValue}px))`)
        $(window).one('resize', (e) => {
            keyboardOpen = false;
            $('#sticky_nav').css('transform', ``)
        });
    });

    console.log(e);
});






$(window).scroll(function () {
    if (keyboardOpen) {
        return;
    }

    if (this.innerWidth > 650) {

      if ($(window).scrollTop() > 0 && !opening) {

            if (!is_middle) {
                stopTremolio = false;
                $("#blocco_player").addClass("collapsed");
                if($("#container_button_open_right").hasClass("open")){
                    $("#container_button_open_right").trigger("click");
                }
                is_middle = true;
              setTimeout(() => {
                stopTremolio = true;
                if($(window).scrollTop() == 0){
                  console.log("scrolltop");
                  // $("#blocco_player").removeClass("collapsed");
                  is_middle = false;
                }
              }, 600);

            }
        } else {
          if(stopTremolio == true){

            //console.log("else qui tricche ballacche")
            // $("#blocco_player").removeClass("collapsed");
            is_middle = false;
          }
        }
    } else {
        if ($(window).scrollTop() > 0 && !can_be_open) {
            chiudiPlayer();
            can_be_open = true;
        } else if ($(window).scrollTop() == 0) {
            // apriPlayer();
            can_be_open = false;
        }
    }
});

// PARTE COMMENTATA PLAYER OLD FINO QUI



$(window).on('resize', function () {
    if(curWidth == $(window).width()){
        return;
    }
    curWidth = $(window).width();
    if ($("#mobile_player").hasClass("open")) {
        $(".icona_player.mobile.selected_mobile").trigger("click");
    }

    //SERIE A BANNER 
    if (window.innerWidth < 650) {
        if (window.radioId != 13) {
            $("#blocco_player").removeClass("collapsed");
        }
    }

    if (window.innerWidth < 700) {
        if (window.radioId == 13) {
            $("#info-song-seriea").addClass("display-none");
            $("#info-song-seriea-mobile").removeClass("display-none");
        }
    } else {
        if (window.radioId == 13) {
            $("#info-song-seriea").removeClass("display-none");
            $("#info-song-seriea-mobile").addClass("display-none");
        }
    }


});

$(window).on('resize', function () {
    if (curWidth == $(window).width()) {
        return;
    }
    curWidth=$(window).width();
    if ($("#mobile_player").hasClass("open")) {
        $(".icona_player.mobile.selected_mobile").trigger("click");
    }

    if ($("#extra_right_content").hasClass("open")) {
        $("#container_button_open_right").trigger("click");
    }
});





//// Valutare se tenere pulsante
$(document).on({
    click: function () {

        if($("#blocco_player").hasClass("collapsed")){
            opening = true;
            clearInterval(interval);
            $("#blocco_player").removeClass("collapsed");
            setTimeout(() => {
                opening = false;
                can_be_open = false;
            }, 500);
            return;
        } else{
          opening = false;

          $("#blocco_player").addClass("collapsed");
          if($("#container_button_open_right").hasClass("open")){
            $("#container_button_open_right").trigger("click");
          }
          setTimeout(() => {
            opening = true;
            can_be_open = true;
          }, 500);
        }
    }
}, "#open_player_sticky");


function chiudiPlayer() {

    eventBus.emit(EVENTS.LIVE_CLOSE_MENU);

    $("#blocco_player").hide();
    $(".player-explode").removeClass("open");
    $(".testo_helper_player").html("APRI");
    $("#blocco_player").removeClass("collapsed");
    $("#che_canzone_era").removeClass("traslated_playing");
    $("#now_playing").removeClass("traslated_playing");
    if($("#container_button_open_right").hasClass("open")){
        $("#container_button_open_right").trigger("click");
    }

    if ($("#mobile_player").hasClass("open")) {
        $(".icona_player.mobile.selected_mobile").trigger("click");
    }

}



function apriPlayer() {

    eventBus.emit(EVENTS.LIVE_OPEN_MENU);

    $("#blocco_player").slideDown();
    $(".player-explode").addClass("open");
    $(".testo_helper_player").html("CHIUDI");

}

window.togglePlayer = () => {
    console.log('*********************');
    
    opening = true;
    if ($(".player-explode").hasClass("open")) {
        chiudiPlayer();
    } else {
        apriPlayer();
    }
    eventBus.emit(EVENTS.PLAYER_MODE_CHANGED);
    setTimeout(() => {
        opening = false;
        can_be_open = false;
    }, 500);
}

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return false;
}

/* all'evento di login dell'utente */

eventBus.on(EVENTS.RENDER_USER_LOGGED, function (user) {

    $("#immagine_profilo_nav").attr("src", user.avatar);
    $("#immagine_profilo_not_logged_container").hide();
    $("#immagine_profilo_logged_container").css("display", "inline-flex");
    $("#immagine_profilo_logged_container").addClass("user_logged");
});

/* all'evento di logout dell'utente*/

eventBus.on(EVENTS.RENDER_USER_NOT_LOGGED, function (events) {
    $("#immagine_profilo_nav").attr("src", "");
    $("#immagine_profilo_not_logged_container").show();
    $("#immagine_profilo_logged_container").css("display", "none");
    $("#immagine_profilo_logged_container").removeClass("user_logged");
});


$(document).on({
    click: function () {

        if (window.innerWidth <= 650) {
            $("#che_canzone_era").toggleClass("traslated_playing");
            $("#now_playing").toggleClass("traslated_playing");
        }
    }
}, ".go_next_tab");

/////SPOSTARE NELLA SEZIONE GIUSTA




$(document).on({
    click: function () {

        $("#mobile_ham_menu").toggleClass("menu_mobile");
        $(this).toggleClass("is_open");

        if(!$(this).hasClass("is_open")){
            closeAllMenu(this);
        }
    }
}, ".hamburger_menu");



///CLICK SU MENU CON SOTTO MENU


function toggleHamMenu() {
    $("#mobile_ham_menu").removeClass("menu_mobile");
    $(".hamburger_menu").removeClass("is_open");
}

$(document).on({
    click: function (e) {

        if (e.target &&
            e.target.className != "paginator" &&
            e.target.className != "paginator selected" &&
            e.target.classList != "select_mostra_news clickable" &&
            e.target.parentElement.className != "select_mostra_news clickable" &&
            e.target.id != "filter_order_selected" &&
            e.target.id != "toggle_filter" &&
            e.target.offsetParent &&
            e.target.offsetParent.id != "toggle_filter") {
            closeAllMenu();
            toggleHamMenu();
        }

    }
}, "main");

$(document).on({
    click: function () {

        eventBus.emit(EVENTS.LIVE_CHAT_SEND);

        let textarea = $(this).parents(".container_messaggio").find("textarea").val();

        if (textarea != "") {
            user.sendMessage(textarea);
            // $(".emojionearea-editor").text("");
        }

    }
}, ".icona_invio");


$(document).on({
    click: function () {
        if($(this).hasClass("multi_voice_menu_cont")){
            closeAllMenu(this);
            $(this).find(".sub_menu_container").toggle();
            $(this).find(".dropdown_main_menu").toggleClass("selected");
        } else{

            $(".voice_menu_to_click").removeClass("selected");
            $(this).addClass("selected");

            //// seleziona anche voce di menu mobile corrispondente
            var id_menu = $(this).attr("data-id");
            $(".voice_menu_to_click_mobile").removeClass("selected");
            $(".voice_menu_to_click_mobile[data-id='"+id_menu+"']").addClass("selected");
        }


    }
}, ".voice_menu_to_click");



$(document).on({
    click: function () {
        $(".voice_menu_to_click_mobile").removeClass("open");
        $(".sub_menu_container_mobile").hide();
        if($(this).hasClass("multi_voice_menu_cont")){

            $(".selected_open").not($(this)).removeClass("selected_open").addClass("selected");
            if($(this).hasClass("selected")){
                $(this).removeClass("selected");
                $(this).addClass("selected_open");
            }


            $(this).find(".sub_menu_container_mobile").show();
            $(this).find(".dropdown_main_menu").addClass("selected_mobile");
            $("#right_menu_mobile_cont").addClass("with_multi_voice");
            $(".default_evidenza").hide();

            $(this).addClass("open");

        } else{
            closeAllMenu(this);
        }


    }
}, ".voice_menu_to_click_mobile");

//
// $(document).on({
//     click: function () {
//         closeAllMenu(this);
//     }
// }, ".sub_menu");
//
//
// $(document).on({
//     click: function () {
//         closeAllMenu(this);
//     }
// }, ".sub_menu_mobile");
//
//


function closeAllMenu(me) {
    ///MOBILE
    $(".sub_menu_container_mobile").hide();
    $(".dropdown_main_menu").removeClass("selected_mobile");
    $("#right_menu_mobile_cont").removeClass("with_multi_voice");
    $(".default_evidenza").show();
    $(".voice_menu_to_click_mobile").removeClass("open");
    $(".voice_menu_to_click_mobile.selected_open").removeClass("selected_open").addClass("selected");


    //DESKTOP
    if (me) {
        $(".sub_menu_container").not($(me).find(".sub_menu_container")).hide();
        $(".dropdown_main_menu").not($(me).find(".dropdown_main_menu")).removeClass("selected");
    } else {
        $(".sub_menu_container").hide();
        $(".dropdown_main_menu").removeClass("selected");
    }


    ///menu categorie magazine
    if($(".option_select_container").is(":visible")){
        $(".option_select_container").slideUp();
        $("#toggle_select_categoria").find(".icon_dropdown").removeClass("open");
        $("#toggle_select_categoria-cat").find(".icon_dropdown").removeClass("open");
    }

    ///select ordine podcast in dettaglio podcast
    $(".filter_container").hide();

}
//
//
// $(document).on({
//     click: function () {
//        closeAllMenu();
//     }
// }, ".secondary_menu");



window.closeAllMenu = closeAllMenu;
window.toggleHamMenu = toggleHamMenu;
